import { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Trash2, X, Save, Pencil } from "lucide-react";
import ImageUploader from "@/components/ImageUploader";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });
const empty = { title: "", image: "", order: 0 };

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);

  const load = () => axios.get(`${API}/api/gallery`, { headers: getHeaders() }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(empty); setEditing("new"); };
  const openEdit = (g) => { setForm({ title: g.title, image: g.image, order: g.order }); setEditing(g); };
  const close = () => setEditing(null);

  const handleSave = async () => {
    setLoading(true);
    try {
      if (editing === "new") await axios.post(`${API}/api/admin/gallery`, form, { headers: getHeaders(), withCredentials: true });
      else await axios.put(`${API}/api/admin/gallery/${editing.id}`, form, { headers: getHeaders(), withCredentials: true });
      close(); load();
    } catch { alert("Hata"); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    await axios.delete(`${API}/api/admin/gallery/${id}`, { headers: getHeaders(), withCredentials: true });
    load();
  };

  return (
    <div data-testid="admin-gallery">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>Galeri / Katalog</h1>
        <button onClick={openNew} className="flex items-center gap-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors" data-testid="add-gallery-btn">
          <Plus size={16} /> Yeni Görsel
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((g) => (
          <div key={g.id} className="bg-[#161923] border border-white/5 rounded-xl overflow-hidden group" data-testid={`gallery-${g.id}`}>
            <div className="relative aspect-square">
              <img src={g.image?.startsWith("/api") ? `${API}${g.image}` : g.image} alt={g.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                <button onClick={() => openEdit(g)} className="p-2 bg-white/20 rounded-lg text-white hover:bg-white/30"><Pencil size={14} /></button>
                <button onClick={() => handleDelete(g.id)} className="p-2 bg-red-500/40 rounded-lg text-white hover:bg-red-500/60"><Trash2 size={14} /></button>
              </div>
            </div>
            <div className="p-3">
              <p className="text-white text-sm font-medium truncate">{g.title}</p>
              <p className="text-slate-600 text-xs">Sıra: {g.order}</p>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full bg-[#161923] border border-white/5 rounded-xl p-12 text-center text-slate-500">Henüz galeri görseli eklenmedi</div>}
      </div>

      {editing !== null && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
          <div className="bg-[#1a1d27] border border-white/10 rounded-2xl w-full max-w-lg">
            <div className="flex items-center justify-between p-5 border-b border-white/5">
              <h2 className="text-lg font-bold text-white" style={{ fontFamily: "Outfit" }}>{editing === "new" ? "Yeni Görsel" : "Görsel Düzenle"}</h2>
              <button onClick={close} className="text-slate-400 hover:text-white"><X size={20} /></button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Başlık</label>
                <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="admin-input" data-testid="form-gallery-title" />
              </div>
              <ImageUploader value={form.image} onChange={(v) => setForm({ ...form, image: v })} label="Görsel" />
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Sıra</label>
                <input type="number" value={form.order} onChange={(e) => setForm({ ...form, order: parseInt(e.target.value) || 0 })} className="admin-input" data-testid="form-gallery-order" />
              </div>
            </div>
            <div className="flex justify-end gap-3 p-5 border-t border-white/5">
              <button onClick={close} className="px-4 py-2 rounded-lg text-sm text-slate-400 hover:text-white border border-white/10 transition-colors">İptal</button>
              <button onClick={handleSave} disabled={loading || !form.title || !form.image} className="flex items-center gap-2 px-4 py-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white rounded-lg text-sm font-semibold transition-colors disabled:opacity-50" data-testid="form-gallery-save">
                <Save size={14} /> {loading ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
